import { render, staticRenderFns } from "./SharedSpecimenPostureReport.vue?vue&type=template&id=2db5eaa6"
import script from "./SharedSpecimenPostureReport.vue?vue&type=script&lang=js"
export * from "./SharedSpecimenPostureReport.vue?vue&type=script&lang=js"
import style0 from "./SharedSpecimenPostureReport.vue?vue&type=style&index=0&id=2db5eaa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports